#import "../fragments/lead-fragment.graphql"

mutation UpdateLeadCustomFieldValue($lead: UpdateLeadInputFieldInput!) {
    updateLead(input: {lead: $lead}) {
        lead {
            ...Lead
        }
    }
}
